import { defineMessages, useIntl } from 'react-intl';

import { ProductRating, PureButton } from '@jsmdg/yoshi';
import { ProductType } from '../../../shared/enums';
import { isExperience } from '../../../shared/product-safeguards';
import { useProduct } from '../../hooks/useProduct';
import { ProductParticipants } from '../ProductParticipants';

const messages = defineMessages({
    a11yTextRating: {
        defaultMessage: '{value} Sterne von 5 aus {count} Bewertungen',
    },
});

const RatingAndParticipantsContainer = ({
    handleRatingClick,
}: {
    readonly handleRatingClick: () => void;
}): JSX.Element | null => {
    const product = useProduct();
    const intl = useIntl();
    const { rating, type } = product;

    return (
        <div className="d-flex">
            {Boolean(type !== ProductType.VALUE_VOUCHER && rating?.value && rating?.count > 0) && (
                <PureButton className="pt-1x mr-6x" onClick={handleRatingClick}>
                    <ProductRating
                        a11yTextRating={intl.formatMessage(messages.a11yTextRating, {
                            value: rating.value,
                            count: rating.count,
                        })}
                        rating={rating.value}
                        count={rating.count}
                        className="align-items-center"
                    />
                </PureButton>
            )}
            {isExperience(product) && (
                <div className="pt-1x">
                    <ProductParticipants
                        maxParticipants={product.maxParticipants}
                        minParticipants={product.minParticipants}
                    />
                </div>
            )}
        </div>
    );
};

export { RatingAndParticipantsContainer };
